import * as React from 'react';
import { Helmet } from 'react-helmet-async';

import { config } from '@/config';
import { GuestGuard } from '@/components/auth/guest-guard';
import { Layout } from '@/components/auth/layout';
import { SignInForm } from '@/components/auth/sign-in-form';

export default function SignInPage(): React.JSX.Element {
  return (
    <>
      <Helmet>
        <title>Sign in | Auth | {config.site.name}</title>
      </Helmet>
      <Layout>
        <GuestGuard>
          <SignInForm />
        </GuestGuard>
      </Layout>
    </>
  );
}
